import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

const Robustand = () => {
  return (
    <div className="Robustand p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
            <h2>iOS App Development Services We Offer</h2>
            <p>
              Team up with a tech-driven iOS app development company in the USA
              to build custom applications for accelerated online business
              engagements, immersive usability, and expansion.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Start iOS App Development
            </Link>
          </Col>
          <Col xs={12} md={6} lg={7} xl={6} xxl={6} className="offset-xl-1">
            <div className="robustscroll">
              <div className="robust-box">
                <div className="robust-content">
                  <h4>iOS App Consultation</h4>
                  <p>
                    Our iOS app development process begins with need-based
                    analysis to determine feature stack, resources, and
                    time-to-market. This initial roadmap paves the way for a
                    purpose-built, compatible final product for different Apple
                    devices including the iPhone, iPad, Apple Watch, and Apple
                    TV.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>iOS App UI/UX Design</h4>
                  <p>
                    Users remember apps for an easy-to-navigate intuitive design
                    – and our iOS app development service is a hallmark for
                    creating user-centric solutions. Based on tested user
                    personas and modern usability benchmarks our iOS UI/UX
                    designers craft appealing interfaces, that also fit with
                    functional needs.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Core iOS Development</h4>
                  <p>
                    Transform your concepts into polished, end-user-focused iOS
                    apps for diverse Apple devices like iPhone, iPad, Apple
                    Watch, and Apple TV. Our skilled iOS application developers
                    use Swift and Objective-C with Xcode for scalable,
                    high-performance development and App Store deployment.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>QA & Testing</h4>
                  <p>
                    We focus on security and performance throughout the iOS
                    application development process. As a dedicated iPhone app
                    development company, we ensure your app is glitch-free and
                    fast with a combination of manual and automated testing
                    techniques to identify and fix issues.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Migration & Upgrades</h4>
                  <p>
                    Ensure seamless transitions and retain core functionalities
                    in your iOS applications. We use advanced tools like Xcode,
                    Swift Migration Assistant, and TestFlight to update your
                    app’s codebase and features, ensuring compatibility with the
                    latest iOS versions and enhanced performance.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Cross-Device Rollout</h4>
                  <p>
                    With a most sought-after process and novel technologies, our
                    custom iOS mobile app development company ensures fewer
                    turnarounds and quicker time-to-market. We help brands
                    maintain a consistent presence on all devices users engage
                    with, providing a unified experience.
                  </p>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Robustand;
